export const HeadphoneIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8307 14.1673H14.9974C14.5374 14.1673 14.1641 13.794 14.1641 13.334V9.16732C14.1641 8.70732 14.5374 8.33398 14.9974 8.33398H15.8307C16.7516 8.33398 17.4974 9.07982 17.4974 10.0007V12.5007C17.4974 13.4215 16.7516 14.1673 15.8307 14.1673Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 14.1673H4.16667C3.24583 14.1673 2.5 13.4215 2.5 12.5007V10.0007C2.5 9.07982 3.24583 8.33398 4.16667 8.33398H5C5.46 8.33398 5.83333 8.70732 5.83333 9.16732V13.334C5.83333 13.794 5.46 14.1673 5 14.1673Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4193 8.33333V7.91667C15.4193 4.925 12.9943 2.5 10.0026 2.5C7.01094 2.5 4.58594 4.925 4.58594 7.91667V8.33333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5208 17.7083H9.47917C8.90417 17.7083 8.4375 17.2417 8.4375 16.6667C8.4375 16.0917 8.90417 15.625 9.47917 15.625H10.5208C11.0958 15.625 11.5625 16.0917 11.5625 16.6667C11.5625 17.2417 11.0958 17.7083 10.5208 17.7083Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5625 16.666H13.3333C14.2542 16.666 15 15.9202 15 14.9993V14.166"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
